<div class="leads-status-container">
  <div class="header-section">
    <div class="header-content">
      <div class="title-wrapper">
        <div class="header-metrics">
          <div class="overview-metrics">
            @for (metric of leadOverviewMetrics; track metric.label) {
              <div
                class="overview-metric-card"
                [class]="'overview-metric-card tone-' + metric.tone"
              >
                @if (
                  metric.tone !== "unassigned" &&
                  showMetricCelebration[metric.label]
                ) {
                  <div class="metric-confetti" aria-hidden="true">
                    <span class="confetti-piece piece-1"></span>
                    <span class="confetti-piece piece-2"></span>
                    <span class="confetti-piece piece-3"></span>
                    <span class="confetti-piece piece-4"></span>
                    <span class="confetti-piece piece-5"></span>
                    <span class="confetti-piece piece-6"></span>
                  </div>
                }
                <span
                  class="info-icon"
                  [attr.data-tooltip]="metric.description"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="2"
                    />
                    <path
                      d="M12 16v-4"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <circle cx="12" cy="8" r="1" fill="currentColor" />
                  </svg>
                </span>
                <div class="summary-label">
                  {{ metric.label }}
                </div>
                <div
                  class="metric-value"
                  [attr.title]="
                    metric.format === 'currency-short'
                      ? formatExactCurrency(metric.target)
                      : null
                  "
                >
                  {{ animatedMetricValues[metric.label] }}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="header-right">
        <button class="view-leads-btn" (click)="onViewMyLeads()" type="button">
          <span>View My Leads</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M13 7L18 12M18 12L13 17M18 12H6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>

  @if (totalLeads === 0) {
    <div class="empty-state">
      <div class="empty-state-icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
          <path
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h4 class="empty-state-title">No Assigned Leads</h4>
      <p class="empty-state-message">
        There are currently no leads assigned to your CDFI. Lead status summary
        will appear here once they are assigned.
      </p>
    </div>
  }

  @if (totalLeads !== 0 && totalLeadsStatus !== 0) {
    <div class="status-section-subtitle">Assigned Lead Status</div>
    <div class="status-chart-wrapper collapse-animation" id="tour-status-cards">
      <div class="status-pie-shell" aria-hidden="false">
        <svg class="status-pie-chart" viewBox="0 0 220 220" role="img">
          <circle
            class="status-pie-track"
            cx="110"
            cy="110"
            [attr.r]="pieChartRadius"
          />
          @for (segment of pieSegments; track segment.statusLabel) {
            <circle
              class="status-pie-segment"
              cx="110"
              cy="110"
              [attr.r]="pieChartRadius"
              [attr.stroke]="segment.color"
              [attr.stroke-dasharray]="segment.strokeDasharray"
              [attr.stroke-dashoffset]="segment.strokeDashoffset"
              [attr.aria-label]="
                segment.displayLabel + ': ' + segment.count + ' leads'
              "
              (mouseenter)="onPieSegmentHover($event, segment)"
              (mousemove)="onPieSegmentHover($event, segment)"
              (mouseleave)="onPieSegmentLeave()"
              (click)="onLeadsStatusClick(segment.statusLabel)"
            ></circle>
          }
        </svg>

        <div class="status-pie-center" aria-hidden="true">
          <div class="center-total">{{ animatedTotalLeads }}</div>
          <div class="center-label">Assigned Leads</div>
        </div>

        @if (pieTooltip) {
          <div
            class="status-pie-tooltip"
            role="tooltip"
            [style.left.px]="pieTooltip.left"
            [style.top.px]="pieTooltip.top"
          >
            <div class="tooltip-header">
              <span
                class="tooltip-color-dot"
                [style.background]="pieTooltip.color"
              ></span>
              <span class="tooltip-label">{{ pieTooltip.label }}</span>
            </div>
            <div class="tooltip-meta">
              {{ pieTooltip.count }} leads
              <span class="tooltip-divider"></span>
              {{ pieTooltip.percentage }}%
            </div>
          </div>
        }
      </div>

      <div class="status-pie-legend">
        @for (segment of pieSegments; track segment.statusLabel) {
          <button
            type="button"
            class="status-legend-item"
            [attr.data-status]="segment.statusLabel"
            (click)="onLeadsStatusClick(segment.statusLabel)"
          >
            <span
              class="legend-color-dot"
              [style.background]="segment.color"
            ></span>
            <span class="legend-content">
              <span class="legend-label">{{ segment.displayLabel }}</span>
              <span class="legend-meta">{{ segment.percentage }}%</span>
            </span>
            <span class="legend-count">{{ segment.count }}</span>
          </button>
        }
      </div>
    </div>
  }
</div>
